import { createFileRoute } from "@tanstack/react-router";

import { Page, QuoteForm } from "../components/site";
import { SITE } from "../lib/seo-data";

export const Route = createFileRoute("/hoe-het-werkt")({
  head: () => ({
    meta: [
      { title: "Hoe werkt offertes vergelijken? | offerto" },
      {
        name: "description",
        content:
          "In drie stappen van aanvraag naar offertes: klus omschrijven, elektriciens matchen, prijzen vergelijken. Gratis en vrijblijvend.",
      },
      { property: "og:title", content: "Hoe werkt offertes vergelijken?" },
      {
        property: "og:description",
        content: "In drie stappen gratis en vrijblijvend offertes van erkende elektriciens.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/hoe-het-werkt` },
      { property: "og:locale", content: "nl_NL" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}/hoe-het-werkt` }],
  }),
  component: HoeHetWerkt,
});

const steps = [
  {
    t: "1. Omschrijf je klus",
    d: "Vul je postcode in en kies het type werk. Extra details helpen de elektricien een scherpere prijs te geven.",
  },
  {
    t: "2. Wij matchen elektriciens",
    d: "We selecteren tot 5 erkende bedrijven die in jouw regio werken en dit soort klussen doen.",
  },
  {
    t: "3. Vergelijk en kies",
    d: "Je ontvangt de offertes per e-mail. Vergelijk prijs, planning en reviews en kies zelf wie, of kies niemand.",
  },
];

const faq = [
  {
    q: "Wat kost het aanvragen van offertes?",
    a: "Niets. Het aanvragen en vergelijken van offertes is volledig gratis en geheel vrijblijvend. Je betaalt geen aanmeldingskosten en zit nergens aan vast, ook niet na het ontvangen van offertes.",
  },
  {
    q: "Hoe snel heb ik reactie?",
    a: "Na het indienen van je aanvraag ontvang je direct een bevestiging. De aangesloten elektriciens krijgen je aanvraag direct in hun dashboard. De meeste aanvragen krijgen binnen één werkdag de eerste reactie, bij spoedgevallen zoals storingen vaak sneller.",
  },
  {
    q: "Hoeveel offertes ontvang ik?",
    a: "Je aanvraag wordt gedeeld met maximaal vijf erkende elektriciens uit jouw regio die het betreffende werk uitvoeren. Je ontvangt dus maximaal vijf offertes, waardoor je prijzen, planning en reviews goed kunt vergelijken.",
  },
  {
    q: "Zijn de elektriciens gecontroleerd?",
    a: "We werken uitsluitend met bedrijven die zijn geregistreerd bij de Kamer van Koophandel en beschikken over de juiste certificeringen, zoals VCA-gecertificeerde monteurs. Daarnaast worden alle elektriciens beoordeeld door eerdere klanten via reviews, zodat je de ervaringen van anderen kunt meewegen in je keuze.",
  },
  {
    q: "Moet ik een offerte accepteren?",
    a: "Nee, je zit nergens aan vast. Je vergelijkt de offertes op prijs, planning en beoordelingen en kiest zelf welke elektricien je inschakelt. Past er geen offerte bij je wensen of budget, dan doe je er gewoon niets mee. Je hoort verder niets meer van ons.",
  },
  {
    q: "Welke informatie heb ik nodig voor mijn aanvraag?",
    a: "Een aanvraag bestaat uit je postcode, het type werk, een korte omschrijving van de klus en eventueel foto's. Hoe meer details je deelt, hoe scherper de elektriciens hun prijs kunnen opgeven. Foto's van de situatie helpen daarbij extra.",
  },
  {
    q: "Kan ik foto's van de klus meesturen?",
    a: "Ja, tijdens de aanvraag kun je foto's van de situatie uploaden. De elektriciens zien deze foto's direct bij je aanvraag, zodat ze een beter beeld krijgen van de klus en een nauwkeurigere offerte kunnen opstellen.",
  },
  {
    q: "Wat als ik een spoedklus heb?",
    a: "Bij storingen of andere spoedsituaties kun je dit in de aanvraag aangeven. Elektriciens in jouw regio ontvangen de aanvraag direct en kunnen vaak dezelfde of de volgende dag langskomen, afhankelijk van hun planning.",
  },
];

function HoeHetWerkt() {
  return (
    <Page
      title="Zo werkt het"
      intro="Vind dé elektricien voor je project: dien je aanvraag in ongeveer één minuut in, ontvang offertes van maximaal vijf betrouwbare bedrijven en vergelijk gratis en vrijblijvend."
    >
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {steps.map((s) => (
          <div key={s.t} className="rounded-lg border border-border bg-card p-6">
            <h2 className="text-lg font-bold">{s.t}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{s.d}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-16 text-2xl font-extrabold tracking-tight">Veelgestelde vragen</h2>
      <dl className="mt-6 divide-y divide-border rounded-lg border border-border bg-card">
        {faq.map((f) => (
          <div key={f.q} className="p-6">
            <dt className="font-semibold">{f.q}</dt>
            <dd className="mt-2 text-sm text-muted-foreground">{f.a}</dd>
          </div>
        ))}
      </dl>

      <div className="mt-12">
        <QuoteForm />
      </div>
    </Page>
  );
}
